import { dangerouslyGetFeatureGateSync } from '@trello/feature-gate-client';
import {
  isRouteFullyModernized,
  routeDefinitions,
  type RouteIdType,
} from '@trello/router/routes';

import { isReactRoutingEnabled } from './isReactRoutingEnabled';

const routeGateCache: Partial<Record<RouteIdType, boolean>> = {};

/**
 * Checks if the feature gate for a specific route is enabled.
 */
export const isRouteModernized = (routeId: RouteIdType): boolean => {
  // If the react routing feature gate is not enabled, then we should always return false.
  if (!isReactRoutingEnabled()) {
    return false;
  }

  if (routeGateCache[routeId] === undefined) {
    const route = routeDefinitions[routeId];

    if (isRouteFullyModernized(route)) {
      routeGateCache[routeId] = true;
    } else {
      const featureGate = route.modernizationFeatureGate;
      routeGateCache[routeId] =
        !!featureGate && dangerouslyGetFeatureGateSync(featureGate);
    }
  }
  return routeGateCache[routeId];
};
